<template>
    <v-container grid-list-xs>
        <v-row class="mt-5">
            <v-col>
                <v-sheet class="pa-5 sheet center" elevation="3">
                    <PageHeader>
                        <template #header>
                            <h4>Processing</h4>
                        </template>
                    </PageHeader>
                    <div class="loading-wrapper">
                        <Loader />
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    import { applicationState, sessionState } from "@/state"

    export default {
        created() {
            this.$router.push(
                `/providers/${sessionState.providerKey}/modes/${applicationState.applyMode}/offerReviewNext`,
            )
        },
    }
</script>

<style lang="scss" scoped>
    .loading-wrapper {
        height: 50vh;
        margin-top: 130px;
    }
</style>
